import { isEmpty, isUndefined, findIndex, isArray } from 'lodash';
import { ISectionSchema } from "../components/Section";
import { IControlSchema } from "../components/Controls";

class RuleManagers {
  public run(sections: Array<ISectionSchema>, values: Array<{ controlid: string, value: any }>) : void {
    for (const section of sections) {
      const controls: Array<IControlSchema> = section.controls;
      this.round(controls, values)
    }
  }

  // private getValue(controlId: string, values: Array<{ controlId: string, value: any }>): any {
  //   const index = findIndex(values, (x: any) => x.controlid === controlId);
  //   const value = index > -1 ? values[index].value : null;
  //
  //   return value;
  // }

  private round(controls: Array<IControlSchema>, values: Array<{ controlid: string, value: any }>) : void {
    for(const ctrl of controls) {
      if(ctrl.hasOwnProperty('controls')) {
        this.round(ctrl['controls'], values)
      }
      if (!isUndefined(ctrl.visible) && Array.isArray(ctrl.visible)) {
        let visible = false;
        let k = ctrl.visible.length;
        while (k--) {
          const linkedValue = values.filter(value => String(value.controlid) === String(ctrl.visible[k].field));
          if (linkedValue
            && linkedValue.length === 1
            && ctrl.visible[k].rule === "has_value"
            && ctrl.visible[k].values.map(value => String(value)).indexOf(String(linkedValue[0].value.label)) > -1
          ) {
            visible = true;
          }
        }
        ctrl['vsbl'] = visible;
        // const targetValue = this.getValue(ctrl.rule.controlTergetId, values);
        // const rule = ctrl.rule;

        // switch (rule.option) {
        //     //equal
        //     case 0: ctrl["visible"] = !isEmpty(targetValue.label) && ctrl.rule.value === targetValue;
        //         break;
        //     //not equal
        //     case 1: ctrl["visible"] = !isEmpty(targetValue.label) && ctrl.rule.value !== targetValue;
        //         break;
        //     //In
        //     case 2:
        //         if (isArray(targetValue) && Array.from(targetValue).every(t => t.hasOwnProperty('value') &&  t.hasOwnProperty('label'))) {
        //           ctrl["visible"] =targetValue &&
        //                           Array.from(targetValue).some((t: any) => t.value.toString() === ctrl.rule.value);
        //         } else {
        //           ctrl["visible"] = !isEmpty(targetValue) && (ctrl.rule.value.indexOf(targetValue) > -1);
        //         }
        //         break;
        //     //not in
        //     case 3:
        //         ctrl["visible"] = !isEmpty(targetValue) && (ctrl.rule.value.indexOf(targetValue) === -1);
        //         break
        //     case 5:
        //         ctrl["visible"] =targetValue &&
        //         Array.from(targetValue).some((t: any) => t.value.toString() === ctrl.rule.value);
        //         break;
        // }
      }
      else ctrl['vsbl'] = ctrl.visible;

    }

  }

}
export default RuleManagers;
